import PropTypes from 'prop-types';
import React, { useMemo, ReactNode, CSSProperties, useEffect, useState } from 'react';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import styles from './Container.scss';
import { useAlert } from 'contexts/alert/AlertContext';
import { isAuthenticated } from 'services/Auth/AuthService';

const rootClassName = styles.rootClassName;

interface ContainerProps {
  title?: string;
  className?: string;
  noPadding?: boolean;
  style?: CSSProperties;
  children?: ReactNode;
}

export default function Container(props: ContainerProps) {
  const { showAlert } = useAlert();


  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const result = await isAuthenticated();
      setAuthenticated(result);
    };
    checkAuth();
  }, []);

  const classes = useMemo(
    () =>
      getMergedClassNames([
        rootClassName,
        'scroll-secondary',
        props.className ? props.className : '',
        props.noPadding ? `${rootClassName}-no-padding` : '',
        authenticated && showAlert === false ? `${rootClassName}-logged` : '',
        authenticated && showAlert === true ? 'alert-shown' : '',
      ]),
    [props.className, props.noPadding, showAlert, authenticated]
  );

  const title = useMemo(
    () => (props.title ? <h2>{props.title}</h2> : null),
    [props.title]
  );

  return (
    <div className={classes} style={{ ...(props.style || {}) }}>
      {title}
      {props.children}
    </div>
  );
}

Container.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  noPadding: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node,
};